import { AccessibilityOption } from 'owa-accessibility-option';
import { KeyboardShortcutsOption } from 'owa-shortcut-option';
import { OptionSubCategory } from 'owa-options-core';

let accessibilitySubCategory: OptionSubCategory = {
    key: 'accessibility',
    titleStringKey: 'optionSubcategory_accessibility',
    options: [KeyboardShortcutsOption, AccessibilityOption],
};

export default accessibilitySubCategory;
